import Popover from "@storeblocks/popover";
import ColorWrapper from "Components/ColorWrapper";
import { DittoCoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCard";
import { DittoCoverageCardDetails } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCardDetails";
import { useGetCurrentPrices } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.hooks";
import {
  CoverageDescription,
  CoverageWrap,
  Description,
} from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.styles";
import { CoverageCardHeader } from "Components/Form/Card/styled";
import {
  getCollectionOfDittoComponents,
  getComponentTextByFieldId,
} from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { ChildCoverage } from "Store/interfaces/products/coverage";
import { useCoveragePriceCalculations } from "Store/priceCalculation/priceCalculationHooks";
import { isDefined } from "Utils/functions";
import { useFormikContext } from "formik";
import React from "react";
import { ChildPriceFormValues } from "../../childProductPriceInterfaces";
import { ChildCoveragePaymentPrice } from "./ChildCoveragePaymentPrice";
import { SelectableChildCoveragePayment } from "./SelectableChildCoveragePayment";
import {
  HeaderWrapper,
  PaymentHeaderWrapper,
} from "./selectableChildCoveragePayment.styled";

export const ChildCoveragesHalfG = (): React.ReactElement => {
  const formProps = useFormikContext<ChildPriceFormValues>();
  const coverages = useCoveragePriceCalculations();

  const { child: productCardTextComponents } = getCollectionOfDittoComponents(
    TextComponentNameLevel1.COVERAGE_CARD,
  );
  const childCoverageBasic = coverages.find(
    ([coverageName, _]) => coverageName === ChildCoverage.BASIC,
  );
  const childCoverageExtra = coverages.find(
    ([coverageName, _]) => coverageName === ChildCoverage.EXTRA,
  );
  const childCoverageExtraHalfG = coverages.find(
    ([coverageName, _]) => coverageName === ChildCoverage.EXTRA_HALF_G,
  );

  const { monthlyPrice: childCoverageExtraHalfGMonthlyPrice } =
    useGetCurrentPrices({
      prices: childCoverageExtraHalfG?.[1].prices ?? [],
      priceFilterValue: undefined,
    });
  const { monthlyPrice: childCoverageExtraMonthlyPrice } = useGetCurrentPrices({
    prices: childCoverageExtra?.[1].prices ?? [],
    priceFilterValue: undefined,
  });

  const isExtraCoverageSelected =
    formProps.values.coverage === ChildCoverage.EXTRA ||
    formProps.values.coverage === ChildCoverage.EXTRA_HALF_G;

  return (
    <>
      {isDefined(childCoverageBasic) && (
        <DittoCoverageCard
          key={childCoverageBasic[0]}
          fieldName="coverage"
          product={ProductBackendName.CHILD}
          coverage={childCoverageBasic[0]}
          textComponents={productCardTextComponents}
          prices={childCoverageBasic[1].prices}
          padding="32px 16px 16px 16px"
        />
      )}
      {isDefined(childCoverageExtra) && isDefined(childCoverageExtraHalfG) && (
        <ColorWrapper
          coverageDetailsCard
          dynamicInsuranceDetailsCard
          selected={isExtraCoverageSelected}
          padding="32px 16px 16px 16px"
        >
          <CoverageCardHeader>
            <HeaderWrapper>
              <label style={{ paddingLeft: "32px" }}>
                {getComponentTextByFieldId(
                  productCardTextComponents,
                  `coveragelabel-${childCoverageExtra[0].toLowerCase()}`,
                ) ?? ""}
              </label>
            </HeaderWrapper>
          </CoverageCardHeader>
          <CoverageWrap>
            <Description fw={400} size={"14px"}>
              <CoverageDescription>
                {getComponentTextByFieldId(
                  productCardTextComponents,
                  `description-${childCoverageExtra[0].toLowerCase()}`,
                ) ?? ""}
              </CoverageDescription>
            </Description>

            <PaymentHeaderWrapper>
              <label
                style={{
                  alignItems: "center",
                  display: "flex",
                  flexFlow: "row nowrap",
                }}
              >
                Velg forsikringssum (G) for uførhet{" "}
                <Popover>
                  {
                    "Grunnbeløpet i folketrygden (G) benyttes som grunnlag for å beregne norske trygde- og pensjonsytelser. Grunnbeløpet pr. 1. mai 2024 er 124 028 kroner. "
                  }
                </Popover>
              </label>
            </PaymentHeaderWrapper>

            <SelectableChildCoveragePayment
              id={childCoverageExtraHalfG[0]}
              value={childCoverageExtraHalfG[0]}
              label={"0,5 G"}
              labelDetails={
                <ChildCoveragePaymentPrice
                  price={childCoverageExtraHalfGMonthlyPrice}
                />
              }
              checked={formProps.values.coverage === ChildCoverage.EXTRA_HALF_G}
            >
              Ca. 62 335 kr i året fordelt på månedlige utbetalinger
            </SelectableChildCoveragePayment>

            <SelectableChildCoveragePayment
              id={childCoverageExtra[0]}
              value={childCoverageExtra[0]}
              label={"1 G"}
              chipText={"Mest populær"}
              labelDetails={
                <ChildCoveragePaymentPrice
                  price={childCoverageExtraMonthlyPrice}
                />
              }
              checked={formProps.values.coverage === ChildCoverage.EXTRA}
            >
              Ca. 124 028 kr i året fordelt på månedlige utbetalinger
            </SelectableChildCoveragePayment>

            <DittoCoverageCardDetails
              product={ProductBackendName.CHILD}
              cardIsSelected={isExtraCoverageSelected}
              coverage={
                formProps.values.coverage === ChildCoverage.EXTRA
                  ? childCoverageExtra[0]
                  : childCoverageExtraHalfG[0]
              }
              showExcludedCoverages={false}
            />
          </CoverageWrap>
        </ColorWrapper>
      )}
    </>
  );
};
